<script lang="ts">
	import { page } from '$app/state';
	import Header from '$lib/layout/header.svelte';
	import NewsletterBanner from '$lib/storyblok/blocks/newsletterBanner.svelte';
	import Footer from '$lib/storyblok/pages/footer.svelte';

	let { children } = $props();

	// temporary hack until we have the "universal" header
	let labLp = $derived(
		page.route.id === '/(marketing)/lab/[...slug]' &&
			(page.data.story?.full_slug?.startsWith('lp/') ||
				page.data.story?.full_slug?.startsWith('food-recycler'))
	);

	let showNewsletter = $derived(
		!page.route.id ||
			(!page.route.id.startsWith('/(marketing)/order-now') &&
				!['/', '/food-recycler', '/reviews'].includes(page.url.pathname))
	);
	let showHeader = $derived(
		!page.route.id?.startsWith('/(marketing)/order-now') &&
			page.route.id !== '/(marketing)' &&
			page.route.id !== '/(marketing)/[slug]' &&
			!labLp
	);
	let showFooter = $derived(!page.route.id || !page.route.id.startsWith('/(marketing)/order-now'));
</script>

{@render children?.()}

{#if showHeader}
	<Header />
{/if}

{#if showNewsletter}
	<NewsletterBanner
		content={{
			bg_color: 'green-olive',
			cta_label: 'Submit',
			cta_title: 'Sign up for updates',
			placeholder: 'Enter your email here',
			text: {
				type: 'doc',
				content: [
					{
						type: 'paragraph',
						content: [{ type: 'text', text: 'Stay in the loop.' }]
					},
					{
						type: 'paragraph',
						content: [{ type: 'text', text: 'Subscribe to Mill updates.' }]
					}
				]
			}
		}}
	/>
{/if}

{#if showFooter}
	<Footer />
{/if}
